import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataModalAddresses } from '../../../../redux/actions/partials/modals/modalAddresses';
import { handleChangeDataModalAddAddress } from '../../../../redux/actions/partials/modals/modalAddAddress';
import { handleChangeDataUserAddresses } from '../../../../redux/actions/pages/user/addresses';
import { handleChangeProfileData, handleSetActiveAddress } from "../../../../redux/actions/pages/user/user";
import { USERS_ADDRESSES_GET } from '../../../../apis';
import useOutsideClick from './hooks/useOutsideClick'; 
import apiRequest from '../../../../utils/apiRequest';


const ModalAddresses = (props) => {

	const dispatch = useDispatch();

	const { isMobile } = useSelector(state => state.general);
	const { isActive} = useSelector(state => state.modalAddresses);
	const { token, profile } = useSelector(state => state.login);
	const { activeAddress } = useSelector(state => state.user);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);
	const { addresses } = useSelector(state => state.addresses);


	useEffect(() => {
	    if(isActive) 
	    	apiGetAddresses();
	}, [isActive]);


	const apiGetAddresses = () => {
		if(! isBackdropLoading) {
			apiRequest({
			    dispatch,
			    endpoint: USERS_ADDRESSES_GET,
			    method: 'get',
			    token: token, 
			    onSuccess: (res) => {
			    	res.addresses.map((address, index) => {
			    		address.isPrimary = address.id == activeAddress?.id;
			    	});
			      	dispatch(handleChangeDataUserAddresses('addresses', res.addresses))
			    },
		  	});
		}
	};


	const handleSelectAddress = (addressId) => {
		const addressData = addresses.find(address => address.id === addressId);

		dispatch(handleSetActiveAddress(addressData));

		handleClose();
	};


	const handleClose = () => {
		dispatch(handleChangeDataModalAddresses('isActive', false))
		setTimeout(() => {
            dispatch(handleChangeDataModalAddresses('isOpen', false));
        }, 250);
    };    


    const outerRef = useRef(null);
  	const centerBoxRef = useRef(null);
  	useOutsideClick(outerRef, centerBoxRef, handleClose, [ModalAddresses]);


    const handleChangeInputs = (event) => {
    	const {name, value} = event.target;
    	dispatch(handleChangeDataModalAddresses(name, value));
    };


    const showModalAddAddress = () => {
		dispatch(handleChangeDataModalAddAddress('isOpen', true));
		setTimeout(() => dispatch(handleChangeDataModalAddAddress('isActive', true)), 0);

		handleClose();
	};


	const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

	// const inputRefs = useRef({});
	// const handleOnInputFocus = (key) => {
 //        const currentInput = inputRefs.current[key];
 //        if (currentInput && errorTxt.length === 0) {
 //            dispatch(handleChangeInputLoginPage('inputClass', 'input-focused'));
 //            currentInput.classList.add("input-focused");
 //        }
 //    };




    return (

		<div ref={outerRef} className={`ReactModal__Overlay ${isActive ? 'ReactModal__Overlay--after-open' : ''}`} style={{position: 'fixed', inset: '0px', backgroundColor: 'rgba(0, 0, 0, 0.3)', zIndex: '11'}}>
			<div ref={centerBoxRef} className="ReactModal__Content ReactModal__Content--after-open bg-neutral-000 absolute overflow-y-hidden rounded-medium styles_Modal__TsaRp" tabIndex="-1" role="dialog" aria-modal="true" style={ !isMobile ? {width: '540px'} : {width: '100%', maxHeight: '100vh', height: '100%'} }>
				<div className="flex flex-col h-full overflow-y-hidden styles_ModalLayout__y3Bs1" style={{paddingTop: '59px', paddingBottom: '86px'}}>
					<div className="w-full z-1 bg-neutral-000 fixed top-0 right-0 px-5" width="420" height="58.59375">
						<div className="flex items-center border-complete-b-200">
							<div className="break-words py-3 grow">
								<div className="flex items-center grow">
									<p className="grow text-h5 text-neutral-900">
										<span className="relative">آدرس‌های شما
										</span>
									</p>
								</div>
							</div>
							<div className="grow text-h5">
							</div>
							<div className="flex cursor-pointer" onClick={handleClose}>
								<svg data-test-id="close-modal-icon-button" style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
									<use xlinkHref="#close"></use>
								</svg>
							</div>
						</div>
					</div>
					<div className="grow flex flex-col overflow-y-auto">
						<div className="grow flex flex-col styles_children__hHq5Q py-4 px-5">
							
							<div class="h-full overflow-auto">
							{ addresses.map((address, key) => (
								<div class="mb-4" key={key}>
									<div onClick={() => handleSelectAddress(address.id)} class={`flex items-start cursor-pointer px-4 py-3 rounded w-full transition-all ${address.isPrimary ? 'border-complete-secondary-700' : 'border-complete-200'}`}>
										<div class="flex items-start w-full">
											<div class="flex">
												<svg style={{width: '24px', height: '24px', fill: `${address.isPrimary ? 'rgb(0, 142, 178)' : 'rgb(98, 102, 109)'}`}}>
													<use xlinkHref="#pin"></use>
												</svg>
											</div>
											<div class="mr-4 grow -mt-1">
												<p class="text-body-1 text-secondary-700">
													
												</p>
												<p class="text-body-1 text-neutral-600">
													<div>
														<div class={`${address.isPrimary? 'text-secondary-700' : 'text-body-1'}`}>{address.address}
														</div>
														<div>کد پستی: {toPersianDigits(address.postalCode)}
														</div>
														<div class="flex">
															<div> گیرنده: {address.receiverName}  
															</div>
															<div class="mr-0.5">
																<span>
																	<span class="mx-1">|
																	</span>{toPersianDigits(address.receiverMobile)}
																</span>
															</div>
														</div>
													</div>
													
												</p>
											</div>
											<div class="flex cursor-pointer mr-auto">
												<svg style={{width: '24px', height: '24px', fill: 'rgb(98, 102, 109)'}}>
													<use xlinkHref="#edit"></use>
												</svg>
											</div>
										</div>
									</div>
								</div>
							))}
							</div>

						</div>
					</div>
					<div class="w-full z-1 bg-neutral-000 px-5 py-4 fixed bottom-0 right-0 shadow-1-top" width="500" height="54.09375">
						<div onClick={showModalAddAddress} class="break-words py-3 cursor-pointer" data-cro-id="shipping-add-new-address">
							<div class="flex items-center grow">
								<div class="flex shrink-0 ml-2">
									<svg style={{width: '24px', height: '24px', fill: 'rgb(231, 19, 61)'}}>
										<use xlinkHref="#addSimple"></use>
									</svg>
								</div>
								<p class="grow text-body1-strong text-[#E7133D]">
									<span class="relative">افزودن آدرس جدید</span>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>



        
    );
}

export default ModalAddresses;
